import { ADD_IMAGE_URL } from '../../utils/constantes'

export default function addImageUrl(payload) {
    return{
        type: ADD_IMAGE_URL,
        payload
    }
}
